<app-timeout-content
  [componentInstance]="ComponentInstance?.TimeOutComponent" />
